// extracted by mini-css-extract-plugin
export default {"container":"styles_container__P54vi","recommendedWrapper":"styles_recommendedWrapper__b4dBj","content":"styles_content__8xBk-","info":"styles_info__a+Bav"};